// extracted by mini-css-extract-plugin
export var aboveInput = "_mm-0";
export var actionButton = "_mm-5";
export var actionButtonContainer = "_mm-1";
export var actionIcon = "_mm-6";
export var aiInfoContainer = "_mm-2";
export var attachmentWrapper = "_mm-7";
export var bold = "_mm-3";
export var checkIcon = "_mm-8";
export var clickingRecipientBar = "_mm-11";
export var commentThreadSwitch = "_mm-a";
export var draftImage = "_mm-b";
export var draftImageContainer = "_mm-c";
export var draftImages = "_mm-e";
export var editButton = "_mm-g";
export var editor = "_mm-f";
export var editorContainer = "_mm-y";
export var editorErrorTooltipWrapper = "_mm-9";
export var headerDivider = "_mm-h";
export var icon = "_mm-i";
export var info = "_mm-j";
export var internal = "_mm-n";
export var internalDivider = "_mm-k";
export var internalMessage = "_mm-l";
export var messageInputCard = "_mm-m";
export var messageInputForm = "_mm-o";
export var messageInputFormInternal = "_mm-p";
export var options = "_mm-q";
export var publicMessageCustomer = "_mm-s";
export var publicMessageMerchant = "_mm-r";
export var removeImageButton = "_mm-d";
export var replyButtons = "_mm-t";
export var showSignatureButton = "_mm-u";
export var spinner = "_mm-v";
export var verticalButtonDivider = "_mm-4";
export var visibilitySelector = "_mm-w";
export var warning = "_mm-x";
export var wrappingText = "_mm-z";
export var writingInternalNoteTopBorder = "_mm-10";